var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        {
          staticClass: "folder-card pb-1 pt-2",
          class: _vm.cardColorClass,
          attrs: { outlined: "" },
          on: { click: _vm.openFile },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex justify-space-between align-center" },
            [
              _c(
                "p",
                {
                  staticClass:
                    "font-weight-bold text-body-1 mb-0 truncate-text",
                },
                [_vm._v(_vm._s(_vm.file.name))]
              ),
              _c(
                "v-menu",
                {
                  attrs: { "offset-y": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function ({ on, attrs }) {
                        return [
                          _c(
                            "v-icon",
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "grey--text text--darken-2",
                                  attrs: { small: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                "v-icon",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_vm._v(" mdi-dots-vertical ")]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        { on: { click: _vm.viewInfo } },
                        [_c("v-list-item-title", [_vm._v("Información")])],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { on: { click: _vm.openFile } },
                        [_c("v-list-item-title", [_vm._v("Descargar")])],
                        1
                      ),
                      _c(
                        "v-list-item",
                        {
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.$emit("deleteItemFile", _vm.file)
                            },
                          },
                        },
                        [
                          _c(
                            "v-list-item-title",
                            { staticClass: "red--text" },
                            [_vm._v("Eliminar")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.isImage
            ? _c(
                "v-card-text",
                { staticClass: "pa-0 pt-1" },
                [
                  _c("v-img", {
                    staticStyle: { "object-fit": "cover", width: "100%" },
                    attrs: { src: _vm.file.path, height: "127px", contain: "" },
                  }),
                ],
                1
              )
            : _c(
                "v-card-text",
                {
                  staticClass:
                    "text-center justify-center align-center d-flex pa-0",
                  staticStyle: { height: "100%" },
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mb-1 icon-file",
                      staticStyle: { height: "127px" },
                      attrs: { large: "", color: _vm.iconColor },
                    },
                    [_vm._v(" " + _vm._s(_vm.fileIcon) + " ")]
                  ),
                ],
                1
              ),
          _c("v-card-actions", { staticClass: "d-flex pa-0 pt-1" }, [
            _c("div", { staticClass: "d-flex align-center" }, [
              _c("span", { staticClass: "text-body-2 grey--text me-2" }, [
                _vm._v(_vm._s(_vm.file.user_name)),
              ]),
              _c("span", { staticClass: "text-body-2 grey--text" }, [
                _vm._v(
                  _vm._s(_vm.formatUtils.formatDate(_vm.file.creation_date))
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.view_info,
            callback: function ($$v) {
              _vm.view_info = $$v
            },
            expression: "view_info",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Información del archivo"),
              ]),
              _c("v-card-text", { staticClass: "mt-5" }, [
                _c("p", [
                  _c("strong", [_vm._v("Usuario:")]),
                  _vm._v(" " + _vm._s(_vm.file.user_name)),
                ]),
                _c("p", [
                  _c("strong", [_vm._v("Fecha de creación:")]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.formatUtils.formatDateString(_vm.file.creation_date)
                      )
                  ),
                ]),
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.view_info = false
                        },
                      },
                    },
                    [_vm._v("Cerrar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }